<template>
	<div class="accordion">
		<div class="accordion__item accordion__item_one" v-if="!isActiveFirstStep">{{isTitleEnterCode}}</div>
		<div v-if="isActiveFirstStep" class="accordion__container">
			<div class="accordion__title accordion__title_one">Заполните ключ QR с карты</div>
			<div class="accordion__card-info-wrapper">
				<div class="accordion__card-info" :class="{'accordion__card-info_error': isStatusValidation !== 'Ключ активации'}">
					<div class="accordion__card-info-title" :class="{'accordion__card-info-title_error': isStatusValidation !== 'Ключ активации'}">{{isStatusValidation}}</div>
					<div class="accordion__card-info-inputs">
						<input ref="firstInput" type="text" placeholder="XXXX" class="accordion__card-info-input" v-model="firstArea" @keydown="enterValue('', true)" @paste="enterValue(1, true)" @keydown.delete="deleteValue">
						<div class="accordion__dash"></div>
						<input ref="secondInput" type="text" placeholder="XXXX" class="accordion__card-info-input" v-model="secondArea" @keydown="enterValue('', true)" @paste="enterValue(2, true)" @keydown.delete="deleteValue">
						<div class="accordion__dash"></div>
						<input ref="thirdInput" type="text" placeholder="XXXX" class="accordion__card-info-input" v-model="thirdArea" @keydown="enterValue('', true)" @paste="enterValue(3, true)" @keydown.delete="deleteValue">
						<div class="accordion__dash"></div>
						<input ref="fourInput" type="text" placeholder="XXXX" class="accordion__card-info-input" v-model="fourArea" @keydown="enterValue('', true)" @paste="enterValue(4, true)" @keydown.delete="deleteValue">
					</div>
				</div>

				<div class="accordion__card-info-text">
					Считайте QR код с карты или введите его в поле слева. 
				</div>
			</div>

			<button class="accordion__button" :disabled="!isDisableBtnActivation" @click="sendActivateCode">Продолжить</button>
		</div>



		<div class="accordion__item accordion__item_two" v-if="!isActiveSecondStep">
			<div class="accordion__title-rate">{{isRateTitle}}</div>
			<div class="accordion__title-device">{{isSelectedModel}}</div>
		</div>
		<div  v-if="isActiveSecondStep" class="accordion__container accordion__container_flex">
			<div>
				<div class="accordion__title accordion__title_two">«Warranty + для Apple»</div>

				<div class="accordion__card-info-wrapper">
					<div class="accordion__card-info" :class="{'accordion__card-info_active' : allowedModelsStatus, 'accordion__card-info_error' : allowedModelsTitle !== 'Серийный номер'}">
						<div class="accordion__card-info-title" :class="{'accordion__card-info-title_active' : allowedModelsStatus, 'accordion__card-info-title_error' : allowedModelsTitle !== 'Серийный номер'}">{{allowedModelsTitle}}</div>
						<input type="text" class="accordion__card-info-input accordion__card-info-input_serial accordion__card-info-input_full-width"
							   @input="checkLatinWord"
							   :disabled="allowedModelsStatus"
							   v-model="serialNumber">
						<img v-if="allowedModelsStatus" class="accordion__check-sn" src="../assets/check-sn.svg" alt="">
					</div>
				</div>


				<button class="accordion__button" :disabled="allowedModelsStatus" @click="checkSN">Проверить</button>
			</div>

			<div class="accordion__right-side">
				<div class="accordion__text">Применим для: </div>
				<div class="accordion__card-info-wrapper accordion__card-info-wrapper_display-block">
					<div class="accordion__title" v-for="model in allowedModels">{{model.name}}</div>
				</div>
				<button class="accordion__button" v-if="allowedModelsStatus" @click="activeFinalCode">Активировать</button>
			</div>
		</div>




		<div class="accordion__item accordion__item_three" v-if="!isActiveThirdStep">Активация</div>
		<div v-if="isActiveThirdStep"  class="accordion__container">
			<div class="accordion__title accordion__title_three">Ваша карта успешно активирована. </div>

			<div class="accordion__card-info-text accordion__card-info-text_format-text accordion__card-info-text_margin">
				В случае возникновения гарантийного случая обращайтесь по телефону 8-800-888-90-99
			</div>

			<button class="accordion__button" @click="resetData">Активировать ещё</button>
		</div>
	</div>
</template>


<script>
	// SAFDASDFHFY7
	import {mapActions, mapMutations, mapState} from 'vuex';
	export default {
		data: () => ({
			isDisableBtnActivation: false,
			firstArea: '',
			secondArea: '',
			thirdArea: '',
			fourArea: '',
			serialNumber: '',
		}),
		computed: {
			...mapState(['isSelectedModel','isRateTitle','isTitleEnterCode','isStatusValidation', 'isActiveSecondStep', 'isActiveFirstStep', 'isActiveThirdStep', 'allowedModels', 'allowedModelsStatus', 'allowedModelsTitle']),
		},
		methods: {
			...mapMutations(['resetCard']),
			...mapActions(['CHECK_VALIDATION_CODE', 'CHECK_SERIAL_NUMBER', 'ACTIVATE_FINAL_CODE']),

			enterValue(step, isNotDelete) {

				if(isNotDelete) {
					setTimeout(() => {
						if(step === 1) {
							this.secondArea = this.firstArea.split('-').join('').split(' ').join('').trim().slice(4, 8);
							this.thirdArea = this.firstArea.split('-').join('').split(' ').join('').trim().slice(8, 12);
							this.fourArea = this.firstArea.split('-').join('').split(' ').join('').trim().slice(12, 16);
							this.firstArea = this.firstArea.split('-').join('').split(' ').join('').trim().slice(0, 4);
						} else if (step === 2) {
							this.thirdArea = this.secondArea.split('-').join('').split(' ').join('').trim().slice(4, 8);
							this.fourArea = this.secondArea.split('-').join('').split(' ').join('').trim().slice(8, 12);
							this.secondArea = this.secondArea.split('-').join('').split(' ').join('').trim().slice(0, 4);
						} else if (step === 3) {
							this.fourArea = this.thirdArea.split('-').join('').split(' ').join('').trim().slice(4, 8);
							this.thirdArea = this.thirdArea.split('-').join('').split(' ').join('').trim().slice(0, 4);
						}

						if(this.firstArea.length > 3) {
							this.$refs.secondInput.focus();
						}

						if(this.secondArea.length > 3) {
							this.$refs.thirdInput.focus();
						}

						if(this.thirdArea.length > 3) {
							this.$refs.fourInput.focus();
						}

						this.isDisableBtnActivation = this.firstArea.length > 3 && this.secondArea.length > 3 && this.thirdArea.length > 3 && this.fourArea.length > 3;

					}, 10)

				}

			},
			deleteValue() {
				if(this.secondArea.length < 1) {
					this.$refs.firstInput.focus();
				} else if (this.thirdArea.length < 1) {
					this.$refs.secondInput.focus();
				} else if (this.fourArea.length < 1) {
					this.$refs.thirdInput.focus();
				}

				this.isDisableBtnActivation = this.firstArea.length > 3 && this.secondArea.length > 3 && this.thirdArea.length > 3 && this.fourArea.length - 1 < 4;
			},

			checkLatinWord() {
				if (!this.serialNumber.match(/^[a-zA-Z, 0-9]+$/)) {
					this.serialNumber = this.serialNumber.replace(/[^a-zA-Z]/g, '');
				}
			},

			checkSN() {
				this.CHECK_SERIAL_NUMBER(this.serialNumber);
			},

			sendActivateCode() {
				let code = this.firstArea + this.secondArea + this.thirdArea + this.fourArea;
				this.CHECK_VALIDATION_CODE(code);
			},

			activeFinalCode() {
				this.ACTIVATE_FINAL_CODE(this.serialNumber);
			},

			resetData() {
				this.serialNumber = '';
				this.firstArea = '';
				this.secondArea = '';
				this.thirdArea = '';
				this.fourArea = '';
				// this.CHECK_SERIAL_NUMBER(this.serialNumber);
				this.$store.dispatch('RESET_DATA');
			},

			setNumberCardFromUrl() {
				let getGet = function(name) {
					let s = window.location.search;
					s = s.match(new RegExp(name + '=([^&=]+)'));
					return s ? s[1] : false;
				}

				if(getGet('key')) {
					this.firstArea = getGet('key').split('-').join('').split('%').join('').trim();
					this.enterValue(1, true);
				}
			}
		},

		mounted() {
			this.setNumberCardFromUrl();
		}
	}
</script>


<link href="https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap" rel="stylesheet">
